/**
 * Settings panel for warehouse dimensions configuration.
 */

import React from 'react';
import { useLayoutEditor } from '../contexts/LayoutEditorContext';

const SettingsPanel: React.FC = () => {
  const { state, dispatch } = useLayoutEditor();
  const { layout, showSettings } = state;

  if (!showSettings || !layout) return null;

  return (
    <div className="p-3 border-t border-gray-200 bg-gray-50">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Varehus-dimensjoner</h3>
      <div className="space-y-2">
        <div>
          <label className="text-xs text-gray-600">Lengde (m)</label>
          <input
            type="number"
            value={layout.dimensions.length}
            onChange={(e) => dispatch({ type: 'UPDATE_DIMENSIONS', field: 'length', value: Number(e.target.value) })}
            className="w-full px-2 py-1 text-sm border rounded"
            min={10}
            max={200}
          />
        </div>
        <div>
          <label className="text-xs text-gray-600">Bredde (m)</label>
          <input
            type="number"
            value={layout.dimensions.width}
            onChange={(e) => dispatch({ type: 'UPDATE_DIMENSIONS', field: 'width', value: Number(e.target.value) })}
            className="w-full px-2 py-1 text-sm border rounded"
            min={10}
            max={200}
          />
        </div>
        <div>
          <label className="text-xs text-gray-600">Hoyde (m)</label>
          <input
            type="number"
            value={layout.dimensions.height}
            onChange={(e) => dispatch({ type: 'UPDATE_DIMENSIONS', field: 'height', value: Number(e.target.value) })}
            className="w-full px-2 py-1 text-sm border rounded"
            min={3}
            max={20}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;
